module.exports = __webpack_public_path__ + "static/media/Agri-Entrepreneur Infographic - Desktop - 12-06-2024 C.9b6d9b53.gif";